"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/gift-card-purchase-type.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fgift-card-purchase-type.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.giftCardPurchaseTypeToJSON = exports.giftCardPurchaseTypeFromJSON = exports.GiftCardPurchaseType = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.giftcard.proto';
/**
 * Represents the way the gift card was purchased.
 */
var GiftCardPurchaseType;
(function (GiftCardPurchaseType) {
    GiftCardPurchaseType["INVALID_GIFT_CARD_PURCHASE_TYPE"] = "INVALID_GIFT_CARD_PURCHASE_TYPE";
    /**
     * DIRECT - Direct order (purchase directly via spending account).
     */
    GiftCardPurchaseType["DIRECT"] = "DIRECT";
    /**
     * POINTS_EXCHANGE - Points exchange order (redeem points to buy gift card).
     */
    GiftCardPurchaseType["POINTS_EXCHANGE"] = "POINTS_EXCHANGE";
    GiftCardPurchaseType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GiftCardPurchaseType || (exports.GiftCardPurchaseType = GiftCardPurchaseType = {}));
function giftCardPurchaseTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_GIFT_CARD_PURCHASE_TYPE':
            return GiftCardPurchaseType.INVALID_GIFT_CARD_PURCHASE_TYPE;
        case 1:
        case 'DIRECT':
            return GiftCardPurchaseType.DIRECT;
        case 2:
        case 'POINTS_EXCHANGE':
            return GiftCardPurchaseType.POINTS_EXCHANGE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return GiftCardPurchaseType.UNRECOGNIZED;
    }
}
exports.giftCardPurchaseTypeFromJSON = giftCardPurchaseTypeFromJSON;
function giftCardPurchaseTypeToJSON(object) {
    switch (object) {
        case GiftCardPurchaseType.INVALID_GIFT_CARD_PURCHASE_TYPE:
            return 'INVALID_GIFT_CARD_PURCHASE_TYPE';
        case GiftCardPurchaseType.DIRECT:
            return 'DIRECT';
        case GiftCardPurchaseType.POINTS_EXCHANGE:
            return 'POINTS_EXCHANGE';
        case GiftCardPurchaseType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.giftCardPurchaseTypeToJSON = giftCardPurchaseTypeToJSON;
//# sourceMappingURL=gift-card-purchase-type.js.map